export default {"src":"/_next/static/media/apple-logo.43ed8d6a.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};